<template>
  <div class="crypto-campus bg--color-01">
    <top-section />
    <about-section />
    <how-it-works />
    <crypto-literacy id="crypto-literacy" />
    <career-guidance id="career-guidance" />
    <why-patex-campus />
    <faq-block />
    <subscribe-block />
  </div>
</template>

<script>
import { getDefaultHeadData } from '@/lib/utils'

export default {
  name: 'CryptoCampus',
  components: {
    TopSection: () => import('@/components/crypto-campus/TopSection.vue'),
    AboutSection: () => import('@/components/crypto-campus/AboutSection.vue'),
    HowItWorks: () => import('@/components/crypto-campus/HowItWorks.vue'),
    CryptoLiteracy: () =>
      import('@/components/crypto-campus/CryptoLiteracy.vue'),
    CareerGuidance: () =>
      import('@/components/crypto-campus/CareerGuidance.vue'),
    WhyPatexCampus: () =>
      import('@/components/crypto-campus/WhyPatexCampus.vue'),
    FaqBlock: () =>
      import(
        /* webpackMode: "eager" */ '@/components/crypto-campus/FaqBlock.vue'
      ),
    SubscribeBlock: () =>
      import(
        /* webpackMode: "eager" */ '@/components/welcome/SubscribeBlock.vue'
      ),
  },
  head () {
    return getDefaultHeadData({
      title: this.$t('meta.cryptoCampus.title'),
      description: this.$t('meta.cryptoCampus.description'),
      img: '/image/meta/og-crypto-campus.png',
      locale: this.$i18n.locale,
    })
  },
  mounted () {
    if (!process.client) return
    this.$nextTick(() => {
      setTimeout(() => {
        const data = this.$route.hash
        const dataId = document.querySelector(data)
        if (data && dataId) this.scrollToElement(dataId)
      }, 300)
    })
  },
  methods: {
    scrollToElement (section) {
      // section.getBoundingClientRect().top
      const top = section.offsetTop - 70 // 40px -- header
      window.scroll({ top, behavior: 'smooth' })
    },
  },
}
</script>

<style scoped lang="scss">
// .crypto-campus {}
</style>
